import { forwardRef } from "react";
import { ArrowLeft } from "lucide-react";
import "../style/ProjectHeader.scss";

const ProjectHeader = forwardRef(({ projectTitle, onBack }, ref) => {
  return (
    <div className="projectHeaderContainer" ref={ref}>
      <button className="backButton" onClick={onBack}>
        <ArrowLeft size={20} />
        <span>Back to Projects</span>
      </button>
      <h1 className="projectTitle">{projectTitle}</h1>
    </div>
  );
});

export default ProjectHeader;
